import React, { useState } from "react";

import AutomatedBoardColumnDetails from "./automatedBoardDetails/AutomatedBoardColumnDetails";
import ManualBoardColumnDetails from "./ManualBoardColumnDetails";
import BoardColumnNormalView from "./BoardColumnNormalView";

export default function BoardColumn({ setCollapsedBoards, board, setClickedPatientId, onDelete, setSelectedBoardStatistics }) {
  const [detailedBoard, setDetailedBoards] = useState(false);

  return (
    <div
      style={{
        height: 687,
        width: 376,
        minWidth: 376,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border: "1px solid #E0DDF7",
        borderRadius: 8,
        backgroundColor: board.type === "manual" ? "rgba(246, 245, 253, 1)" : "white",
      }}
    >
      {!detailedBoard ? (
        <BoardColumnNormalView
          board={board}
          setSelectedBoardStatistics={setSelectedBoardStatistics}
          setClickedPatientId={setClickedPatientId}
          setCollapsedBoards={setCollapsedBoards}
          setDetailedBoards={setDetailedBoards}
          onDelete={onDelete}
        />
      //) : board.type === "manual" ? (
      //  <ManualBoardColumnDetails board={board} setDetailedBoards={setDetailedBoards} />
      ) : (
        <AutomatedBoardColumnDetails board={board} setDetailedBoards={setDetailedBoards} />
      )}
    </div>
  );
}
